<template>
    <img :src="'https://i.lsc-wx.co/profiles/' + userId + '.png'" @error="imageUrlAlt" />
</template>

<script>
	export default {
		name: 'ProfileImage',
        props: [
            'userId'
        ],
		methods: {
            imageUrlAlt(event) {
                event.target.src = "https://i.lsc-wx.co/profiles/default.png"
            }
		},
	}
</script>